import { useTranslation } from 'react-i18next';
import React from 'react';
import { useHistory } from 'react-router-dom';
import CrownImg from '@src/assets/images/crown.png';
import ActionDialog from '@src/new-components/Dialog/ActionDialog';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import CommonButton from '@src/new-components/Button';
import route from '@src/constants/route';

const UpgradeApiAccessPopup = ({ open, onClose }) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <ActionDialog
      open={open}
      title={t('unlockTheApiAccess')}
      styleTitle={{
        textAlign: 'center',
      }}
      contentComponent={
        <Typography
          style={{ textAlign: 'center' }}
          variant="body-16-regular"
          color={COLOR.descriptionGray}
          dangerouslySetInnerHTML={{
            __html: t('limitedFeatureDesc', {
              feature: t('createApi'),
            }),
          }}
        />
      }
      fullWidth
      image={CrownImg}
      imageContainerSize="100px"
      onClose={onClose}
      width="512px"
      actionComponent={
        <CommonButton
          variant="contained"
          onClick={() => {
            onClose();
            history.push(route.PAYMENT);
          }}
          textProps={{
            variantText: 'body-14-semibold',
            color: COLOR.darkBlue,
          }}
          customStyle={{
            height: '40px',
            borderRadius: '8px',
            padding: '8px 24px',
            width: '140px',
          }}
        >
          {t('buyPackageBtnTitle')}
        </CommonButton>
      }
    />
  );
};

export default UpgradeApiAccessPopup;
